import { useState } from "react";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from "./reusable/Button";
import SectionHeader from "./reusable/SectionHeader";
import BusinessPartners from "../assets/images/business_partners.webp";
import { useDispatch } from "react-redux";
import { assistantApplicationsClosed } from "../store/modal/modalSlice";

const Benefits = () => {
  const navigate = useNavigate();
  const customer_benefits = [
    "You would be matched with adept assistants",
    "You would be matched with assistants who have been trained for the job",
    "You would be matched with assistants who can work from any timezone",
    "You would have more time to focus on more important tasks",
    "You don’t have to worry about interviewing and getting the right assistants",
    "Continuous support (training and check-in)",
  ];

  const assistant_benefits = [
    "Training",
    "Upskilling",
    "Working with high impact clients",
    "Continuous support (training and check-in)",
    "Opportunity for career growth",
  ];

  const [benefits, setBenefits] = useState(customer_benefits);

  const [benefits_string, setBenefitsString] = useState('customer_benefits')

  const dispatch = useDispatch()

  var benefits_view = "customer_benefits";

  const [buttonColor, setButtonColor] = useState({
    assistant: "#F7F9FC",
    customer: "#E4E4E8",
  });

  const setCustomerView = () => {
    benefits_view = "customer_benefits";
    setBenefitsView();
    setBenefitsString(benefits_view)
  };

  const setAssistantView = () => {
    benefits_view = "assistant_benefits";
    setBenefitsView();
    setBenefitsString(benefits_view)
  };

  const setBenefitsView = () => {
    if (benefits_view === "customer_benefits") {
      setBenefits(customer_benefits);
      setButtonColor({ assistant: "#F7F9FC", customer: "#E4E4E8" });
    } else if (benefits_view === "assistant_benefits") {
      setBenefits(assistant_benefits);
      setButtonColor({ assistant: "#E4E4E8", customer: "#F7F9FC" });
    }
  };

    const getStarted = () => {
    if (benefits_string === "customer_benefits") {
      // window.open("https://bit.ly/Quickstaff-Waitlist");
      navigate("/signup/customer");
    }
    else if (benefits_string === "assistant_benefits") {
      dispatch(assistantApplicationsClosed())
      // navigate("/signup/assistant");
    }
  }

  return (
    <div id="benefits" className="section_margin">
      <SectionHeader title="Benefits" />
      <div className="flex flex-col-reverse justify-center xl:grid grid-cols-2 gap-x-24 lg:pt-16 items-center">
        <div data-aos="fade-right">
          <div className="flex justify-center xl:justify-start gap-12 mt-8 lg:mt-16 xl:mt-0">
            <div onClick={setCustomerView}>
              <Button
                text="Customer"
                color={buttonColor.customer}
                text_color="#202733"
              />
            </div>
            <div onClick={setAssistantView}>
              <Button
                text="Assistant"
                color={buttonColor.assistant}
                text_color="#202733"
              />
            </div>
          </div>
          {benefits && (
            <div className="my-8 lg:my-16">
              {benefits.map((benefit, i) => {
                return (
                  <div key={i} className="flex items-start my-6">
                    <img
                      className="mr-2 md:mr-4"
                      src="/assets/icons/tick.svg"
                      alt=""
                    />
                    <p className="xl:text-xl" key={i}>
                      {benefit}
                    </p>
                  </div>
                );
              })}
            </div>
          )}
          <div className="flex justify-center xl:justify-start">
            <div onClick={getStarted}>
              <Button text="Get Started"/>
            </div>
          </div>
        </div>
        <div data-aos="fade-up" className="justify-self-end">
          <img
            className="rounded-3xl"
            style={{ width: "513px" }}
            src={BusinessPartners}
            alt=""
          />
        </div>
      </div>
    </div>
  );
};

export default Benefits;
